import React from "react";

import { ContentContainer } from "../../components";
import { notReachable } from "../../types/utilities";

import { PrivacyPolicy } from "./PrivacyPolicy";
import { TermsAndConditions } from "./TermsAndConditions";

type Props = {
  document: "privacy" | "terms";
};

const LegalDocument = ({ document }: Props) => {
  switch (document) {
    case "privacy":
      return <PrivacyPolicy />;
    case "terms":
      return <TermsAndConditions />;
    default:
      return notReachable(document);
  }
};

export const LegalPageContent = ({ document }: Props) => {
  return (
    <ContentContainer>
      <LegalDocument document={document} />
    </ContentContainer>
  );
};
